var indicative = require("indicative");

var Validate = (function() {

    var _validate = function(email, subject, message) {
        var Indicative = new indicative();

        var rules  = {
          email: 'required|email',
          subject: 'required',
          message: 'required'
        };

        var messages = {
          "email.required"      : "Please include a valid email address so we can get back to you",
          "email.email"         : "Please include a valid email address so we can get back to you",
          "subject.required"    : "Please fill out a subject",
          "message.required"    : "We need a message of some sort in order to be helpful"
        };

        var data = {
          email: email,
          subject: subject,
          message: message
        };

        return Indicative
                .validateAll(rules,data, messages)
                .then(function(validation_passed){
                  return true;
                })
                .catch(function(error){
                  var errorMessage = '';
                  for(var i=0, errorLength = error.length; i < errorLength; i++) {
                    errorMessage += error[i].message + '\n';
                  };
                  return errorMessage;
                });
    };

    return {
        validate: _validate
    };

})();

module.exports = Validate;



// WEBPACK FOOTER //
// ./src/common/modules/contact/contactUtils.js